<template>
  <div id="tools-table">
    <span class="table-name">{{$t('tools_table.tools')}}</span>
    <div class="table-wrapper">
      <div class="progress-wrapper">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
      </div>
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div
            class="rTableHead"
            v-for="(header, i) in headers"
            :key="i"
            :style="{ 'width': header.width + '%'}"
          >
            <span>{{header.text}}</span>
          </div>
        </div>
        <div class="rTableRow" v-for="(tool, i ) in tools" :key="i">
          <div class="rTableCell">{{tool.code}}</div>
          <div class="rTableCell">{{tool.description}}</div>
          <div class="rTableCell number-cell">{{tool.length}}</div>
          <div class="rTableCell number-cell">{{tool.diameter}}</div>
          <div class="rTableCell">
              <v-icon class="mr-2" small v-tooltip="$t('tools_table.edit')" @click="editTool(tool)">edit</v-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="text-xs-center">
      <v-pagination v-model="page" :length="pages" @input="changePage"></v-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "tools-table",
  props: ["tools"],
  data() {
    return {
      loading: false,
      headers: [
          {
              text: this.$t('tools_table.code'),
              width: 25
          },
          {
              text: this.$t('tools_table.description'),
              width: 40
          },
          {
              text: this.$t('tools_table.length'),
              width: 15
          },
          {
              text: this.$t('tools_table.diameter'),
              width: 15
          },
          {
              text: this.$t('tools_table.actions'),
              width: 5
          },
      ],
      page: 1,
      pages: 1,
    };
  },
  methods: {
      changePage(){
          this.$emit('pageChanged', this.page);
      },
      editTool(tool){
          this.$emit('toolSelected', tool)
      }
  }
};
</script>

<style scoped>
.table-name {
  margin-left: 10px;
}
</style>